import { isUseHTTPMethodOverrideEnabled } from '@gonfalon/dogfood-flags/dogfood-flags';
import type { Middleware } from 'openapi-fetch';
import createClient, { mergeHeaders } from 'openapi-fetch';

import type { paths } from '../schema-aliases';

export type HttpRouteRecorder = (info: { method: string; transportMethod: string; route: string; url: string }) => void;

let httpRouteRecorder: HttpRouteRecorder | undefined;

export function registerHttpRouteRecorder(recorder: HttpRouteRecorder | undefined) {
  httpRouteRecorder = recorder;
}

const launchdarkly: Middleware = {
  onRequest({ request, schemaPath }) {
    const overridden = isUseHTTPMethodOverrideEnabled() && ['PUT', 'PATCH', 'DELETE'].includes(request.method);
    httpRouteRecorder?.({
      method: request.method,
      transportMethod: overridden ? 'POST' : request.method,
      route: schemaPath,
      url: request.url,
    });
    if (overridden) {
      return new Request(request, {
        method: 'POST',
        headers: mergeHeaders(request.headers, { 'X-HTTP-Method-Override': request.method }),
      });
    }
  },
};

let client: ReturnType<typeof createClient<paths>> | undefined;

export function getClient() {
  if (client === undefined) {
    client = createClient<paths>({
      baseUrl: location.origin,
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    });
    client.use(launchdarkly);
  }

  return client;
}

export function resetClient() {
  client = undefined;
}
